import { StyledH2 } from 'components/common/typography'
import { TitleColumnContainer } from './titleColumn_styles'

const TitleColumn = props =>
  <TitleColumnContainer {...props}>
    <StyledH2 variant={props.small ? 'h3' : 'h2'}>{props.title}</StyledH2>
    {props.children}
  </TitleColumnContainer>

export default TitleColumn
